export default {
  install (Vue) {
    Vue.filter('videoposter', (value) => {
      return `${value}?x-oss-process=video/snapshot,t_5000,f_jpg,ar_auto`
    });
    Vue.filter('videoposter1', (value) => {
      return `${value}?x-oss-process=video/snapshot,t_5000,f_jpg,w_574,h_355,ar_auto`
    });
    Vue.filter('videoposter2', (value) => {
      return `${value}?x-oss-process=video/snapshot,t_5000,f_jpg,w_750,h_431,ar_auto`
    });
    Vue.filter('numbers', (value) => {
      switch (value) {
            case 0:
              return '第一次';
              break;
            case 1:
              return '第二次';
              break;
            case 2:
              return '第三次';
              break;
            case 3:
              return '第四次';
              break;
            case 4:
              return '第五次';
              break;
            case 5:
              return '第六次';
              break;
            case 6:
              return '第七次';
              break;
            case 7:
              return '第八次';
              break;
            case 8:
              return '第九次';
              break;
          }
    });

  }
}
